import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";

import {reactLocalStorage as Storage} from "reactjs-localstorage";

import './inAppOrder.scss';

import FeatherIcon from 'feather-icons-react';

import {Link} from "react-router-dom";




@inject(({ teamUser }) => ({ authCheck: teamUser.authCheck, isLogin: teamUser.isLogin, me:teamUser.me,  updateInAppOrder:teamUser.updateInAppOrder, checkOrder:teamUser.checkOrder, freeEventApply: teamUser.freeEventApply }))
@inject(({ company }) => ({ getSalesReport: company.getSalesReport }))

@observer
class orderEnd extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable salesReport = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);
  @observable isEventFree = false;
  //page
  @observable redirectInfo = {
    is: false,
    pathname: '/welcome'
  }
  @observable orderInfo = {};


  constructor(props) {
    super(props);
    this.init()
  }


  componentDidUpdate(prevProps, prevState){
    // console.log(prevProps)
    // console.log(prevState)
    // console.log(this.props.me)
  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};

      this.store.useExpiryDateDiffNow = moment(moment(this.store.useExpiryDate).format('YYYY-MM-DD')).diff(moment(), 'days')+1;
      this.permissions = this.props.me.permissions;

    }
    else {

      if(Storage.get('token')) {
        //todo 재확인 - 로그인 후 해당 페이지로 넘어 오는 경우 authCheck() 함수 미샐행 할 수 있게.
        //this.props.authCheck();
      }
      // else {
      //   window.location.replace('signIn');
      // }

    }
  };


  render() {


    return (
        <div className="main-content">
          {( this.isLogin && this.teamUser.emailId ) ?
              <div className="basic-info-box">
                <form onSubmit={e => this.onSubmit(e)}>

                  <div className="section-box basic-info-table" id="inAppOrder">
                    <div className="section-tit">
                      <h3>성공적으로 주문이 완료 되었습니다.</h3>
                      <p>{moment(this.store.useExpiryDate).format('YYYY년 MM월 DD일')} 까지 소중한 서비스 이용 기간을 신청해 주셔서 너무나 감사합니다.<br /></p>
                      <Link to={"/inAppOrderList"}><strong>주문내역 보기</strong></Link>
                    </div>

                    <div className="order-end-guide" style={{ marginTop: '30px', padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                      <h5 style={{ marginBottom: '15px', fontWeight: 600 }}>
                        <FeatherIcon icon="info" size="18" style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                        결제 후 처음인 경우
                      </h5>
                      <p style={{ marginBottom: '15px', color: '#555', fontSize: '14px', lineHeight: '1.7' }}>
                        서비스를 시작하려면 아래 설정을 순서대로 진행해 주세요.
                      </p>
                      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        <Link to="/easySetting" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#007bff', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                          <FeatherIcon icon="settings" size="15" /> 설치 & 연동 설정
                        </Link>
                        <Link to="/reviewWriteConfig" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#28a745', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                          <FeatherIcon icon="edit-3" size="15" /> 리뷰 설정
                        </Link>
                      </div>
                    </div>

                    <div className="order-end-guide" style={{ marginTop: '15px', padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                      <h5 style={{ marginBottom: '15px', fontWeight: 600 }}>
                        <FeatherIcon icon="info" size="18" style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                        재결제 후 재활성하기
                      </h5>
                      <p style={{ marginBottom: '15px', color: '#555', fontSize: '14px', lineHeight: '1.7' }}>
                        기존 서비스를 계속 이용하시려면 스킨 활성화 설정을 확인해 주세요.
                      </p>
                      <div>
                        <Link to="/easySetting" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#007bff', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                          <FeatherIcon icon="settings" size="15" /> 스킨 활성화 설정
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              :
              <p className='empty'><a href={'/signin'}>로그인하세요.</a></p>
          }

        </div>
    )
  }
}

export default orderEnd;
